export default __webpack_public_path__ + "static/media/img_download_googleplay.104acd05.svg";